import api from "../utils/api";

export const setWinOpportunity = (data) => {
  let VUE_APP_RDSTATION_SETOPPORTUNITY =
    process.env.VUE_APP_RDSTATION_SETOPPORTUNITY;
  return api.post(VUE_APP_RDSTATION_SETOPPORTUNITY + "SALE", data);
};

export const setLostOpportunity = (data) => {
  let VUE_APP_RDSTATION_SETOPPORTUNITY =
    process.env.VUE_APP_RDSTATION_SETOPPORTUNITY;
  return api.post(VUE_APP_RDSTATION_SETOPPORTUNITY + "OPPORTUNITY_LOST", data);
};

export const setEventConvert = (data) => {
  let VUE_APP_RDSTATION_SETEVENTCONVERT =
    process.env.VUE_APP_RDSTATION_SETEVENTCONVERT;
  return api.post(VUE_APP_RDSTATION_SETEVENTCONVERT + data.indentifier, data);
};
